/* eslint-disable array-callback-return */
import { BarcodeScanner } from '@capacitor-mlkit/barcode-scanning';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { Device } from '@capacitor/device';
import { IonButton, IonIcon, IonItem, IonLabel, IonList, IonLoading, IonPopover, IonSelect, IonSelectOption, IonSkeletonText, useIonToast } from '@ionic/react';
import { MenuItem, Select } from '@material-ui/core';
import { barcodeOutline, chevronDownOutline, close, createOutline, personAddOutline, receiptOutline } from 'ionicons/icons';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import calender, { ReactComponent as MaintenanceIconBlue } from '../assets/CalenderBlue.svg';
import { ReactComponent as MaintenanceIconRed } from '../assets/CalenderRed.svg';
import toolkit, { ReactComponent as RepairIconBlue } from '../assets/toolkitBlue.svg';
import { ReactComponent as RepairIconRed } from '../assets/toolkitRed.svg';
import axios from '../axios';
import { createAssetFields, quickAssetUpdateFields } from '../models/createAssetFields';
import { AppContext } from '../providers/AppContext';
import { getAssigneeList, getDashboard, requestPermissions } from '../utils';


import AssetTimeline from './AssetTimeline';
import Shimmer from './Shimmer';



const AssetOnMapModal: React.FC<{ id: string; fullScreen: boolean }> = ({ id = '', fullScreen = false }) => {

  const { t } = useTranslation();
  const ref = useRef<any>(null);
  const isMounted = useRef(true);


  const { dispatch } = useContext(AppContext);

  const [assetModal, setAssetModal] = useState(true)
  const [quickUpdateToggle, setQuickUpdateToggle] = useState(false)
  const [_data, set_Data] = useState<any>(quickAssetUpdateFields);
  // hide the asset name for the modal
  const showAssetFields = createAssetFields.filter((item) => {
    return item.field !== 'asset_name';
  });
  const [assetDetail, setAssetDetail] = useState<any>(showAssetFields)
  const [asToggle, setAsToggle] = useState(false);
  const [color, setColor] = useState<any>('');
  // const [scanToggle, setScanToggle] = useState(false);
  const [shimmer, setShimmer] = useState(false);
  const [loader, setLoader] = useState(false);
  const [modalToggle, setModalToggle] = useState(false);
  const [assignFragment, setAssignFragment] = useState(false);
  const [user, setUser] = useState([]);
  const [assignee, setAssignee] = useState('');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [activeBRCModal, setActiveBRCModal] = useState(''); // Active Barcode Reader Modal
  const [assetC, setAssetC] = useState('');
  const [serviceFragment, setServiceFragment] = useState(false);
  const [maintenanceFragment, setMaintenanceFragment] = useState(false);
  const [repairRequest, setRepairRequest] = useState([]);
  const [maintenance, setMaintenance] = useState([]);
  const [apiLoader, setApiLoader] = useState(false);
  const [modelo937Fragment, setModelo937Fragment] = useState(false);
  const [modelo937, setModelo937] = useState([]);
  const [optModalFullScr, setOptModalFullScr] = useState(false);
  const [loaderModal, setLoaderModal] = useState(false);
  const [currentSelected, setCurrentSelected] = useState('');

  const [present] = useIonToast();


  const [update, setUpdate] = useState<any>({
    status: '',
    asset_state: '',
    brand: '',
    model: '',
    year: '',
    comment: '',
    asset_component: '',
    attachment: {
      format: ''
    },
    barcode_id: ''
  });

  const handleChangeQuickUpdate = (event: React.ChangeEvent<{ value: unknown; id: any }>) => {
    const formentry: any = { ...update };
    if (event.target.id in formentry) {
      formentry[event.target.id] = event.target.value;
    }
    setUpdate(formentry);
  };


  useEffect(() => {
    getAssetDetail();
  }, []);

  const getAssetDetail = () => {
    isMounted.current = true; // Set isMounted to true
    if (id) {
      if (isMounted.current)
        setShimmer(true);
      axios({
        method: 'get',
        url: `resource/Asset/${id}`,
        headers: {
          Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
        },
      })
        .then((res) => {
          const temp = res?.data?.data;
          if (temp?.asset_category) {
            getAssetCategoryColor(temp.asset_category || '')
          }
          if (isMounted.current) {
            setAssetDetail(temp);
            setModalToggle(true);
          }

        })
        .catch((err) => {
          console.log(err);
        }).finally(() => {
          if (isMounted.current)
            setShimmer(false);
        });
    }
  }

  const getAssetComponentfromBarcodeId = (id: string) => {
    axios({
      method: 'get',
      url: `resource/Asset Components?fields=["name"]&filters=[["barcode_id","=","${id}"]]`,
      headers: {
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
    })
      .then((res) => {
        setAssetC(res?.data?.data[0]?.name)
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const quickStatus = async () => {

    const formentry: any = { ...update };
    formentry.status = assetDetail.status
    formentry.asset_state = assetDetail.asset_state
    formentry.brand = assetDetail.brand
    formentry.model = assetDetail.model
    formentry.year = assetDetail.year
    formentry.comment = assetDetail.comment
    formentry.attachment.value = assetDetail.attachment
    formentry.barcode_id = assetDetail.barcode_id
    setUpdate(formentry);
  };

  const getAssetCategoryColor = (asset_category: string) => {
    axios({
      method: 'get',
      url: `resource/Asset Category/${asset_category}`,
      headers: {
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
    })
      .then((res) => {
        setColor(res?.data?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const SubmitStatusUpdate = async (e: any) => {
    e.preventDefault();
    uploadQSFiles();
  };

  const uploadQSFiles = async () => {
    const formData = new FormData();
    try {
      if (update['attachment']['src']?.length > 0) {
        const response = await fetch(update['attachment'].src?.toString());
        const blob = await response.blob();
        formData.append(
          'file',
          new File([blob], `${new Date()?.getTime()}.${update['attachment']?.format}`, {
            type: `image/${update['attachment']?.format}`,
          })
        );

        formData.append('is_private', '0');
        formData.append('folder', 'Home');
        formData.append('doctype', 'Asset');
        const config: any = {
          headers: {
            Accept: 'application/json',
            Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
          },
        };
        setLoader(true);

        const baseURL = localStorage.getItem('baseUrl') || process.env.REACT_APP_BASE_URL || 'https://admin.hyprism.com/api';
        const urlPart = '/method/upload_file';
        const fetchUrl = urlPart.startsWith('http') 
          ? urlPart 
          : `${baseURL.replace(/\/+$/, '')}/${urlPart.replace(/^\/+/, '')}`;

        const responseFetch = await fetch(fetchUrl, {
          method: 'POST',
          headers: config.headers,
          body: formData,
        });

        if (!responseFetch.ok && responseFetch.status !== 200) {
            const errorText = await responseFetch.text();
            throw Object.assign(new Error(), { response: { data: errorText } });
        }

        const resData = await responseFetch.json();
        update['attachment']['src'] = resData.message.file_url;
        formData.delete('file');
        set_Data(_data);
      }
    } catch (e: any) {
      update['attachment']['src'] = '';
    }
    hitQSupdate();
  };

  const hitQSupdate = async () => {

    const api_data: any = {};
    _data.map((_entry: any) => {
      if (_entry.field === 'asset_component') {

        api_data[_entry.field] = [{ asset_component: assetC }];
      } else if (
        _entry.field === 'status' ||
        _entry.field === 'asset_state' ||
        _entry.field === 'brand' ||
        _entry.field === 'model' ||
        _entry.field === 'year' ||
        _entry.field === 'barcode_id'
      ) {
        if (_entry.field === 'barcode_id') {
          api_data['equipment_number'] = update[_entry.field];
        }
        api_data[_entry.field] = update[_entry.field];
      }
      else if (_entry.field === 'attachment') {
        api_data[_entry.field] = update[_entry.field]['src']
      }
      return null;
    });

    const config: any = {
      method: 'put',
      url: `resource/Asset/${id}`,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
      data: api_data,
    };

    // Update status api
    try {
      setLoader(true);
      await axios(config);
    } catch (error: any) {
      console.log(error);
    }

    // Update comment
    try {
      setLoader(true);
      const config_comment: any = {
        method: 'post',
        url: 'resource/Comment',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
        },
        data: {
          comment_type: 'Comment',
          reference_doctype: 'Asset',
          reference_name: id,
          content: update.comment,
        },
      };

      await axios(config_comment);
    } catch (error: any) {
      console.log(error);
    } finally {
      getDashboardData(); // Refresh Dashboard
      getAssetDetail();
      setQuickUpdateToggle(false);
      setAssetModal(true);
      setLoader(false);
      present({
        message: t('Assets.CreateA.assetUpdateSuccesss'),
        duration: 2000,
      });
      // reset modal
      setUpdate({
        status: '',
        asset_state: '',
        brand: '',
        model: '',
        year: '',
        comment: '',
        asset_component: '',
        attachment: {
          format: ''
        },
        barcode_id: ''
      });
    }
  }

  const getDashboardData = async () => {
    const res: any = await getDashboard('', 'Need Installation');
    dispatch({ type: 'dashboard', payload: res || {} });
    dispatch({ type: 'map', payload: res['geo_map_data'] || [] });
  };

  const handleSelectChange = (event: any) => {
    setAssignee(event.target.value as string);
  };

  const getScan = async (field: any) => {
    setActiveBRCModal(field)
    const info = await Device.getInfo();
    if (info?.platform === 'web') {
      present({
        message: t('Utils.scannerNotSupported'),
        duration: 2000,
      });
      return
    }
    try {
      BarcodeScanner.isSupported().then((result) => {
        if (!result.supported) {
          present({
            message: t('Utils.unsupportDevice'),
            duration: 2000,
          });
        }
      });

      const granted = await requestPermissions();
      if (!granted) {
        present({
          message: t('Utils.noPermission'),
          duration: 2000,
        });
        return;
      }
      const check = await BarcodeScanner.isGoogleBarcodeScannerModuleAvailable()
      if (!check.available)
        BarcodeScanner.installGoogleBarcodeScannerModule()
      const { barcodes } = await BarcodeScanner.scan();
      const scannedValue = barcodes[0]?.displayValue
      handleScan(scannedValue, field);
    } catch (error: any) {
      console.log(error)
    }
  };

  const takeQSPicture = async () => {
    try {
      const image = await Camera.getPhoto({
        quality: 70,
        allowEditing: true,
        resultType: CameraResultType.Uri,
        source: CameraSource.Camera,
      });
      const imageUrl = image.webPath;

      // Can be set to the src of an image now
      const formentry: any = { ...update }
      formentry['attachment'].value = null;
      formentry['attachment'].src = imageUrl;
      formentry['attachment'].format = image.format;

      setUpdate(formentry);
    } catch (e: any) {
      console.log('Error: ', e);
      if (e.toString().includes('cancelled')) {
        present({
          message: t('Utils.cameraCancel'),
          color: 'danger',
          duration: 2000,
        });
      }
      else if (e?.toString()?.includes('denied') || e.includes('access')) {
        present({
          message: t('Utils.cameraErrorPermission'),
          color: 'danger',
          duration: 2000,
        });
      } else {
        present({
          message: e,
          color: 'danger',
          duration: 2000,
        });
      }
    }
  };

  const emptyQSImg = () => {
    const tempData = { ...update };
    tempData.attachment = {
      format: ''
    };
    setUpdate(tempData);
  };

  const loadAssignee = async () => {
    const assignee = await getAssigneeList();
    setUser(assignee);
  }

  const assignUser = async () => {
    setLoader(true);
    const config: any = {
      method: 'post',
      url: `/method/frappe.desk.form.assign_to.add?assign_to=["${assignee}"]&doctype=Asset&name=${id}`,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
    };
    try {
      await axios(config);
      present({
        message: t('Assets.CreateA.assetAssignedSuccess'),
        duration: 2000,
      });
      setAssetModal(true)
      setAssignFragment(false)
      getDashboardData();
      setAssignee('');
    } catch (error: any) {
      console.log(error);
    } finally {
      setLoader(false);
    }

  }

  const handleScan = (data: any, field: any) => {
    if (data && field === 'asset_component') {
      getAssetComponentfromBarcodeId(data);
    }
    if (data) {
      try {
        const tempData = { ...update };
        tempData[field] = data;
        setUpdate(tempData);
      } catch (error: any) {
        console.log(error)
        present({
          message: t('Utils.fetchFail'),
          color: 'danger',
          duration: 4000,
        });
      } finally {
        // setScanToggle(false);
        setActiveBRCModal('');
      }
    }
  };

  const handleChange = async (status: string, val: any) => {
    const formData = new FormData();
    /* set status in value of status in item */
    const tempData: any = [...maintenance];
    const index = tempData.findIndex((item: any) => item.name === val);
    if (index !== -1) {

      tempData[index].status = status;
      setMaintenance(tempData);
    }

    /* set status in value of status in item */
    const tempData1: any = [...repairRequest];
    const index1 = tempData1.findIndex((item: any) => item.name === val);
    if (index1 !== -1) {

      tempData1[index1].status = status;
      setRepairRequest(tempData1);
    }

    setShimmer(false);
    if (fullScreen) {
      setCurrentSelected(val);
    }
    formData.append('status', status);
    const config: any = {
      headers: {
        Accept: 'application/json',
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
    };
    try {
      if (fullScreen) {
        setLoaderModal(true);
      }

      const baseURL = localStorage.getItem('baseUrl') || process.env.REACT_APP_BASE_URL || 'https://admin.hyprism.com/api';
      const urlPart = `method/${maintenanceFragment ? 'preflet_asset.api.update_maintenance_request' : 'preflet_asset.api.update_repair_request'}/${val}`;
      const fetchUrl = urlPart.startsWith('http') 
        ? urlPart 
        : `${baseURL.replace(/\/+$/, '')}/${urlPart.replace(/^\/+/, '')}`;

      const responseFetch = await fetch(fetchUrl, {
        method: 'PUT',
        headers: config.headers,
        body: formData,
      });

      if (!responseFetch.ok && responseFetch.status !== 200) {
          const errorText = await responseFetch.text();
          throw Object.assign(new Error(), { response: { data: errorText } });
      }
      present({
        message: maintenanceFragment ? t('Maintenance.maintenanceUpdate') : t('Service.serviceUpdate'),
        duration: 2000,
      });
      if (fullScreen && optModalFullScr) {
        maintenanceFragment ? getMaintenanceById() : getServiceRequestById();
      }
    } catch (error: any) {
      console.log(error);
      present({
        message: 'Failed to update',
        color: 'danger',
        duration: 2000,
      });
    } finally {
      if (fullScreen) {
        setOptModalFullScr(false);
        setLoaderModal(false);
        setCurrentSelected('');
      }
    }
  }

  const clearFields = () => {
    setMaintenance([]);
    setRepairRequest([]);
  }

  const openMap = (coordinates: any) => {
    const url = 'https://www.google.com.sa/maps/search/' + coordinates;
    window.open(url, '_blank');
  };


  const getServiceRequestById = async () => {
    setApiLoader(true);
    axios({
      method: 'get',
      url: `/method/preflet_asset.api.get_assigned_repair_requests?asset=${assetDetail.name}`,
      headers: {
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
    })
      .then((res) => {

        setRepairRequest(res?.data?.message?.repair_request_list)
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setApiLoader(false);
      });
  };

  const getMaintenanceById = async () => {
    setApiLoader(true);
    axios({
      method: 'get',

      url: `/method/preflet_asset.api.get_assigned_maintenance?asset=${assetDetail.name}`,
      headers: {
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
    })
      .then((res) => {
        console.log(res)
        setMaintenance(res?.data?.message?.maintenance_list)
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setApiLoader(false);
      });
  };

  const loadModelo937 = async () => {
    setApiLoader(true);
    axios({
      method: 'get',

      url: `/resource/Model%20937?fields=[%22nome%22,%22name%22,%22asset%22]&filters=[[%22asset%22,%22=%22,%22${assetDetail.name}%22]]`,
      headers: {
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
    })
      .then((res) => {
        setModelo937(res?.data?.data)
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setApiLoader(false);
      });
  }

  return (
    <div>
      {modalToggle ? <div className='asset-modal-layout'>
        <IonLoading
          cssClass="my-custom-class"
          isOpen={loader}
          onDidDismiss={() => setLoader(false)}
          message={t('Utils.pleasewait')}
        />
        {/* ── Header ─────────────────────────────────────────────────────── */}
        <div style={{
          background: 'linear-gradient(135deg, #1d508d 0%, #2a6db5 100%)',
          padding: '14px 16px 16px',
        }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '12px' }}>
            <div
              onClick={() => { setQuickUpdateToggle(false); setModalToggle(false); }}
              style={{ width: '36px', height: '4px', borderRadius: '99px', background: 'rgba(255,255,255,0.4)', cursor: 'pointer' }}
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
            <div style={{ flex: 1, minWidth: 0, paddingRight: '8px' }}>
              <p style={{ margin: 0, fontSize: '17px', fontWeight: 700, color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {assetDetail['asset_name'] || assetDetail['name']}
              </p>
              {assetDetail['status'] && (
                <span style={{
                  display: 'inline-block', marginTop: '6px', padding: '2px 10px',
                  borderRadius: '20px', fontSize: '11px', fontWeight: 600,
                  background: assetDetail['status']?.includes('Need') ? 'rgba(229,57,53,0.85)' : 'rgba(255,255,255,0.2)',
                  color: '#fff', border: '1px solid rgba(255,255,255,0.3)',
                }}>
                  {assetDetail['status']}
                </span>
              )}
            </div>
            {assetModal ? (
              <div style={{ display: 'flex', gap: '8px', flexShrink: 0, alignItems: 'center', marginTop: '2px' }}>
                <button onClick={() => { setAssignFragment(false); setQuickUpdateToggle(false); setAssetModal(false); setServiceFragment(true); setMaintenanceFragment(false); getServiceRequestById(); }}
                  style={{ background: 'rgba(255,255,255,0.18)', border: 'none', borderRadius: '10px', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                  {assetDetail['status']?.includes('Need Repairing') || assetDetail['status']?.includes('Installed But Not Operational') || assetDetail['status']?.includes('Need Replacement') || assetDetail['status']?.includes('Need Maintenance And Repair')
                    ? <RepairIconRed style={{ width: '18px', height: '18px' }} />
                    : <RepairIconBlue style={{ width: '18px', height: '18px', filter: 'brightness(0) invert(1)' }} />}
                </button>
                <button onClick={() => { setAssignFragment(false); setQuickUpdateToggle(false); setAssetModal(false); setServiceFragment(false); setMaintenanceFragment(true); getMaintenanceById(); }}
                  style={{ background: 'rgba(255,255,255,0.18)', border: 'none', borderRadius: '10px', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                  {assetDetail['status']?.includes('Need Maintenance') || assetDetail['status']?.includes('Need Maintenance And Repair')
                    ? <MaintenanceIconRed style={{ width: '18px', height: '18px' }} />
                    : <MaintenanceIconBlue style={{ width: '18px', height: '18px', filter: 'brightness(0) invert(1)' }} />}
                </button>
                <button onClick={() => { setAssignFragment(false); setQuickUpdateToggle(false); setAssetModal(false); setModelo937Fragment(true); loadModelo937(); }}
                  style={{ background: 'rgba(255,255,255,0.18)', border: 'none', borderRadius: '10px', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                  <IonIcon src={receiptOutline} style={{ fontSize: '18px', color: '#fff' }} />
                </button>
                <button onClick={() => { setAssignFragment(true); setQuickUpdateToggle(false); setAssetModal(false); loadAssignee(); }}
                  style={{ background: 'rgba(255,255,255,0.18)', border: 'none', borderRadius: '10px', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                  <IonIcon src={personAddOutline} style={{ fontSize: '18px', color: '#fff' }} />
                </button>
                <button onClick={() => { setQuickUpdateToggle(true); quickStatus(); setAssetModal(false); }}
                  style={{ background: 'rgba(255,255,255,0.25)', border: '1px solid rgba(255,255,255,0.5)', borderRadius: '10px', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                  <IonIcon src={createOutline} style={{ fontSize: '18px', color: '#fff' }} />
                </button>
              </div>
            ) : (
              <button onClick={() => { setQuickUpdateToggle(false); setAssetModal(true); getAssetDetail(); setAssignFragment(false); setServiceFragment(false); setMaintenanceFragment(false); setModelo937Fragment(false); clearFields(); }}
                style={{ background: 'rgba(255,255,255,0.2)', border: '1px solid rgba(255,255,255,0.4)', borderRadius: '20px', padding: '4px 14px', color: '#fff', fontSize: '12px', fontWeight: 600, cursor: 'pointer' }}>
                ← {t('Utils.Back')}
              </button>
            )}
          </div>
        </div>

        {/* ── Body ── */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '0 0 2rem', WebkitOverflowScrolling: 'touch' }}>
          {/* Assign Fragment */}
          {assignFragment && (
            <div style={{ padding: '16px' }}>
              <p style={{ margin: '0 0 8px', fontSize: '13px', fontWeight: 700, color: '#1d508d', textTransform: 'uppercase', letterSpacing: '0.06em' }}>{t('Assign')}</p>
              <div className="input-container" style={{ marginBottom: '12px' }}>
                <Select className="custom-select" name={assignee} onChange={handleSelectChange} value={assignee}>
                  {user.map((opt: any, i: any) => (
                    <MenuItem value={`${opt}`} key={i}>
                      <section style={{ display: 'flex', height: '1rem' }}>
                        <p style={{ color: 'rgba(31,87,148,1)', marginLeft: '0.2rem', fontSize: '12px', marginTop: 0 }}>{opt}</p>
                      </section>
                    </MenuItem>
                  ))}
                </Select>
              </div>
              <button className="submit-button" onClick={() => assignUser()}>{t('Utils.assignUser')}</button>
            </div>
          )}
          {/* Section heading for sub-fragments */}
          {(serviceFragment || maintenanceFragment || modelo937Fragment) && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '14px 16px 10px' }}>
              {serviceFragment && <img src={toolkit} style={{ width: '18px', height: '18px' }} alt="" />}
              {maintenanceFragment && <img src={calender} style={{ width: '18px', height: '18px' }} alt="" />}
              {modelo937Fragment && <IonIcon src={receiptOutline} style={{ fontSize: '18px', color: '#1d508d' }} />}
              <p style={{ margin: 0, fontSize: '13px', fontWeight: 700, color: '#1d508d', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                {serviceFragment && t('Home.map.bar')}
                {maintenanceFragment && t('Maintenance.Maintenance Request')}
                {modelo937Fragment && t('Model937.model937')}
              </p>
            </div>
          )}
          {/* Service Fragment */}
          {serviceFragment && (
            repairRequest.length > 0 ? repairRequest.map((item, index) => (
              <div key={index + '-1-repair'} style={{ margin: '0 12px 8px', background: '#fff', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', overflow: 'hidden' }}>
                <div style={{ padding: '12px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <p style={{ margin: 0, fontSize: '14px', fontWeight: 700, color: '#1d508d' }}>{item['name']}</p>
                    <p style={{ margin: '2px 0 0', fontSize: '12px', color: '#6b7b8f' }}>{item['name1']}</p>
                  </div>
                  {fullScreen ? (
                    <p onClick={() => { setOptModalFullScr(!optModalFullScr); setCurrentSelected(item['name']); }} className='optionMapClickable'>{t('Service.' + item['status'])}</p>
                  ) : (
                    <IonSelect interface='action-sheet' style={{ color: '#1d508d', fontSize: '13px', fontWeight: 600 }} value={item['status']} placeholder='Status' onIonChange={(e) => handleChange(e.detail.value, item['name'])}>
                      <IonSelectOption value="New">{t('Service.New')}</IonSelectOption>
                      <IonSelectOption value="In Progress">{t('Service.In Progress')}</IonSelectOption>
                      <IonSelectOption value="Faulty">{t('Service.Faulty')}</IonSelectOption>
                      <IonSelectOption value="Completed">{t('Service.Completed')}</IonSelectOption>
                    </IonSelect>
                  )}
                </div>
                {!fullScreen && (
                  <div style={{ borderTop: '1px solid #f0f3f8', padding: '8px 14px' }} onClick={() => { setQuickUpdateToggle(false); setModalToggle(false); }}>
                    <Link to={{ pathname: '/serviceDetail', state: item['name'], search: 'true' }} style={{ fontSize: '12px', color: '#1d508d', fontWeight: 600 }}>{t('Utils.viewDetails')} →</Link>
                  </div>
                )}
                {fullScreen && optModalFullScr && currentSelected === item['name'] && (
                  <div className='mapModalFullScreen'>
                    {['New', 'In Progress', 'Faulty', 'Completed'].map(v => (
                      <div key={v} className='mapOptionsTitle'>{t('Maintenance.' + v)}<input className="radioMapModal" onChange={(e) => handleChange(e.target.value, item['name'])} type="radio" value={v} checked={item['status'] === v} /></div>
                    ))}
                  </div>
                )}
                {loaderModal && <div className='toastMapModal'>{t('Utils.updating')}</div>}
              </div>
            )) : apiLoader ? (
              <div style={{ padding: '12px 16px' }}>
                {[1, 2, 3].map(k => (
                  <div key={k} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                    <IonSkeletonText animated style={{ width: '45%', height: '14px', borderRadius: '8px' }} />
                    <IonSkeletonText animated style={{ width: '25%', height: '14px', borderRadius: '8px' }} />
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ textAlign: 'center', padding: '40px 16px' }}>
                <img src={toolkit} style={{ width: '48px', opacity: 0.35, marginBottom: '8px' }} alt="" />
                <p style={{ color: '#a0aec0', fontSize: '13px' }}>{t('Service.No Service Request')}</p>
              </div>
            )
          )}

          {/* Modelo 937 Fragment */}
          {modelo937Fragment && (
            apiLoader && !modelo937.length ? (
              <div style={{ padding: '12px 16px' }}>
                {[1, 2, 3].map(k => (
                  <div key={k} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                    <IonSkeletonText animated style={{ width: '45%', height: '14px', borderRadius: '8px' }} />
                    <IonSkeletonText animated style={{ width: '25%', height: '14px', borderRadius: '8px' }} />
                  </div>
                ))}
              </div>
            ) : modelo937.length > 0 ? modelo937.map((item, index) => (
              <div key={index + '-modelo-937'} style={{ margin: '0 12px 8px', background: '#fff', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', overflow: 'hidden' }}>
                <div style={{ padding: '12px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <p style={{ margin: 0, fontSize: '14px', fontWeight: 700, color: '#1d508d' }}>{item['nome']}</p>
                    <p style={{ margin: '2px 0 0', fontSize: '12px', color: '#6b7b8f' }}>{item['name']}</p>
                  </div>
                  {!fullScreen && (
                    <Link to={{ pathname: '/model-detail', state: item['name'], search: 'true' }} style={{ fontSize: '12px', color: '#1d508d', fontWeight: 600 }}>{t('Utils.viewDetails')} →</Link>
                  )}
                </div>
              </div>
            )) : (
              <div style={{ textAlign: 'center', padding: '40px 16px' }}>
                <IonIcon src={receiptOutline} style={{ fontSize: '48px', color: '#a0aec0', opacity: 0.5 }} />
                <p style={{ color: '#a0aec0', fontSize: '13px', marginTop: '8px' }}>{t('Model937.noModel937')}</p>
              </div>
            )
          )}

          {/* Maintenance Fragment */}
          {maintenanceFragment && (
            maintenance.length > 0 ? maintenance.map((item) => (
              <div key={item['name1']} style={{ margin: '0 12px 8px', background: '#fff', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', overflow: 'hidden' }}>
                <div style={{ padding: '12px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <p style={{ margin: 0, fontSize: '14px', fontWeight: 700, color: '#1d508d' }}>{item['name']}</p>
                    <p style={{ margin: '2px 0 0', fontSize: '12px', color: '#6b7b8f' }}>{item['name1']}</p>
                    <p style={{ margin: '2px 0 0', fontSize: '11px', color: '#a0aec0' }}>{item['doctype'] === 'MR' ? t('Utils.MR') : t('Utils.MD')}</p>
                  </div>
                  {fullScreen ? (
                    <p onClick={() => { setOptModalFullScr(!optModalFullScr); setCurrentSelected(item['name']); }} className='optionMapClickable'>{t('Maintenance.' + item['status'])}</p>
                  ) : (
                    <IonSelect interface='action-sheet' style={{ color: '#1d508d', fontSize: '13px', fontWeight: 600 }} value={item['status']} placeholder='Status' onIonChange={(e) => handleChange(e.detail.value, item['name'])}>
                      <IonSelectOption value="New">{t('Maintenance.New')}</IonSelectOption>
                      <IonSelectOption value="In Progress">{t('Maintenance.In Progress')}</IonSelectOption>
                      <IonSelectOption value="Completed">{t('Maintenance.Completed')}</IonSelectOption>
                      <IonSelectOption value="Need Repair">{t('Maintenance.Need Repair')}</IonSelectOption>
                    </IonSelect>
                  )}
                </div>
                {!fullScreen && (
                  <div style={{ borderTop: '1px solid #f0f3f8', padding: '8px 14px' }} onClick={() => { setQuickUpdateToggle(false); setModalToggle(false); }}>
                    <Link to={{ pathname: '/maintainanceDetail', state: item['name'], search: 'true' }} style={{ fontSize: '12px', color: '#1d508d', fontWeight: 600 }}>{t('Utils.viewDetails')} →</Link>
                  </div>
                )}
                {fullScreen && optModalFullScr && currentSelected === item['name'] && (
                  <div key={currentSelected} className='mapModalFullScreen'>
                    {['New', 'In Progress', 'Completed', 'Need Repair'].map(v => (
                      <div key={v} className='mapOptionsTitle'>{t('Maintenance.' + v)}<input className="radioMapModal" onChange={(e) => handleChange(e.target.value, item['name'])} type="radio" value={v} checked={item['status'] === v} /></div>
                    ))}
                  </div>
                )}
                {loaderModal && <div className='toastMapModal'>{t('Utils.updating')}</div>}
              </div>
            )) : apiLoader ? (
              <div style={{ padding: '12px 16px' }}>
                {[1, 2, 3].map(k => (
                  <div key={k} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                    <IonSkeletonText animated style={{ width: '45%', height: '14px', borderRadius: '8px' }} />
                    <IonSkeletonText animated style={{ width: '25%', height: '14px', borderRadius: '8px' }} />
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ textAlign: 'center', padding: '40px 16px' }}>
                <img src={calender} style={{ width: '48px', opacity: 0.35, marginBottom: '8px' }} alt="" />
                <p style={{ color: '#a0aec0', fontSize: '13px' }}>{t('Maintenance.No Maintenance Request')}</p>
              </div>
            )
          )}


          {/* Quick Update Form */}
          {quickUpdateToggle && (
            <form onSubmit={(e) => SubmitStatusUpdate(e)} style={{ padding: '0 16px 16px' }}>
              <p style={{ margin: '14px 0 10px', fontSize: '13px', fontWeight: 700, color: '#1d508d', textTransform: 'uppercase', letterSpacing: '0.06em' }}>{t('Assets.CreateA.update')}</p>
              {_data.map((form_field: any, index: any) => {
              //  if (form_field.field === 'asset_component') {
              //   return (
              //     <div key={index} className="input-container">
              //       <label className="label">{t(`Assets.CreateA.${form_field.field}`)}</label>
              //       <Select
              //         className="custom-select"
              //         required={form_field.required}
              //         id={`${form_field.field}_choice`}
              //         name={form_field.field}
              //         multiple
              //         onChange={handleMultiSelectChange}
              //         value={update[form_field.field]}
              //         disabled={
              //           //@ts-ignore
              //           form_field.disabled || false}
              //         input={<Input  className="basic-input" id="select-multiple-chip"  />}
              //         renderValue={(selected) => (
              //           <Box style={{borderRadius:'33rem'}} sx={{ display: 'flex', flexWrap: 'wrap'}}>
              //             {//@ts-ignore
              //             update[form_field.field].map((value,index) => (
              //               <Chip
              //               style={{fontSize:'10px',marginTop:'1px',marginRight:'1px'}} key={index} label={value.label} />
              //             ))}
              //           </Box>
              //         )}
              //       >
              //         {form_field.options &&
              //           form_field.options.map(function (opt: any, indexSelect: any) {
              //             return (
              //               <MenuItem
              //                 value={opt}
              //                 key={`${form_field.field}-${indexSelect}`}
              //                 id={`${opt}_item_${indexSelect}`}
              //               >
              //                    <Checkbox checked={//@ts-ignore
              //                                update[form_field.field].length ? update[form_field.field].filter(itemInArray => itemInArray.id === opt.id)[0]?.id === opt.id : false } />
              //                   <ListItemText primary={//@ts-ignore
              //                     opt.label} />
              //               </MenuItem>
              //             );
              //           })}
              //       </Select>
              //     </div>
              //   );
              // }
              //  else 
              if (form_field.field === 'status' || form_field.field === 'asset_state') {
                // we dont allow users to edit status so not returning it for now
                // (
                //   <div key={index} className="input-container">
                //     <label className="label">{t(`Assets.CreateA.${form_field.field}`)}</label>
                //     <Select
                //       className="custom-select"
                //       required={form_field.required}
                //       id={`${form_field.field}_choice`}
                //       name={form_field.field}
                //       onChange={handleUpdateStatus}
                //       value={update[form_field.field]}
                //       disabled={
                //         //@ts-ignore
                //         form_field.disabled || false}
                //       key={`${form_field.field}-${index}`}
                //     >
                //       {form_field.options &&
                //         form_field.options.map(function (opt, index) {
                //           return (
                //             <MenuItem value={`${opt}`} key={`${form_field.field}-${index}`}>
                //               <section key={`${form_field.field}-${index}`} style={{ display: 'flex', height: '1rem' }}>
                //                 <p
                //                   key={`${form_field.field}-${index}`}
                //                   style={{
                //                     color: 'rgba(31, 87, 148, 1)',
                //                     marginLeft: '0.2rem',
                //                     fontSize: '12px',
                //                     marginTop: '0px',
                //                   }}
                //                 >
                //                   {form_field.translate ? t(`Assets.CreateA.${opt}`) : opt}
                //                 </p>
                //               </section>
                //             </MenuItem>
                //           );
                //         })}
                //     </Select>
                //   </div>
                // );
              }
              else if (form_field.field === 'brand' || form_field.field === 'model' || form_field.field === 'year') {
                return (
                  <div key={index} className="input-container">
                    <label className="label">{t(`Assets.CreateA.${form_field.field}`)}</label>
                    <input
                      className="basic-input"
                      required={false}
                      key={`${form_field.field}-${index}`}
                      id={form_field.field}
                      placeholder={t(`Assets.CreateA.${form_field.field}`)}
                      onChange={handleChangeQuickUpdate}
                      value={update[form_field.field]}
                    />
                  </div>
                );
              }
              else if (form_field.type === 'file') {
                return (
                  <div
                    id={`${form_field.field}-${index}`}
                    className="input-container"
                    key={`${form_field.field}-${index}`}
                  >
                    <label id={`label-${form_field.field}`} className="label">
                      {t(`Assets.CreateA.${form_field.field}`)}
                      {form_field.required ? '*' : null}{' '}
                    </label>
                    <IonButton
                      style={{ marginTop: '1rem', margin: 'auto', width: '40%', color: 'black', marginBottom: '1rem' }}
                      size="small"
                      color="light"
                      onClick={() => takeQSPicture()}
                    >
                      {
                        update[form_field.field]['value'] ? t('Utils.change_image') : t('Utils.image')}
                    </IonButton>
                    <div className="flex justify-center items-center">
                      {
                        update[form_field.field]['value'] ? (
                          <img
                            src={`${localStorage.getItem('baseUrl')?.replace('/api', '')}${update[form_field.field]['value']}`}
                            alt=""
                            style={{
                              width: '60%',
                              margin: 'auto',
                              display: 'block',
                              border: '1px solid lightgray',
                              borderRadius: '12px',
                            }}
                          />
                        ) : (
                          ''
                        )}
                      {
                        update['attachment']['src'] ? <img className="preview-survey-img" src={update['attachment']['src']} alt="" /> : ''}
                      {
                        update['attachment']['src'] ? (
                          <IonIcon className="close-icon" onClick={() => emptyQSImg()} src={close} />
                        ) : (
                          ''
                        )}
                    </div>
                  </div>
                );
              } else if (form_field.type === 'barcode') {
                return (
                  <div
                    id={`${form_field.field}-${index}`}
                    className="input-container"
                    key={`${form_field.field}-${index}`}
                  >
                    <label id={`label-${form_field.field}`} style={{ marginTop: '1rem' }} className="label">
                      {t(`Assets.CreateA.${form_field.field}`)}
                      {form_field.required ? '*' : null}{' '}
                    </label>
                    <div className="flex items-center justify-between basic-input">
                      <input
                        required={form_field.required}
                        className="gps-input"
                        id={form_field.field}
                        placeholder={t(`Assets.CreateA.${form_field.field}`)}
                        value={
                          update[form_field.field]}
                        disabled={true}
                        style={{ width: '80%' }}
                      />
                      <IonIcon onClick={() => getScan(form_field.field)} className="gps-icon" src={barcodeOutline} />
                    </div>
                  </div>
                );
              }
            })}
            <div className="input-container">
              <label className="label">{t('Utils.Comment')}</label>
              <textarea className="textarea" id="comment" placeholder={t('Utils.Add your comment')} onChange={handleChangeQuickUpdate} value={update.comment} />
            </div>
            <button className="submit-button" type="submit" style={{ marginTop: '12px' }}>{t('Assets.CreateA.update')}</button>
          </form>
          )}
          {/* Asset Detail Fields */}
          {shimmer ? <Shimmer ref={ref} /> : assetModal && (
            <div style={{ padding: '8px 0 0' }}>
              {showAssetFields.map((item: any, index) => {
                if (!item.field) return null;
                return (
                  <div key={index + '-asset'} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '10px 16px', borderBottom: '1px solid #f0f3f8' }}>
                    <p style={{ margin: 0, fontSize: '12px', fontWeight: 600, color: '#6b7b8f', flex: '0 0 38%' }}>{t(`Assets.CreateA.${item.field}`)}</p>
                    <div style={{ flex: 1, textAlign: 'right' }}>
                      {item.field === 'northing_easting_point' && assetDetail[item.field] ? (
                        <p onClick={() => openMap(assetDetail[item.field])} style={{ margin: 0, fontSize: '12px', color: '#1d508d', fontWeight: 600, cursor: 'pointer', textDecoration: 'underline' }}>{assetDetail[item.field]}</p>
                      ) : item.field === 'asset_component' ? (
                        <p style={{ margin: 0, fontSize: '12px', color: '#2d3748' }}>{assetDetail[item.field] ? assetDetail[item.field]?.map((m: any) => m.component_name).join(', ') || '-' : '-'}</p>
                      ) : item.field === 'asset_category' ? (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '6px' }}>
                          {color && <div className="color-box" style={{ background: `${color.color}`, borderRadius: '4px', width: '16px', height: '16px' }} onClick={() => setAsToggle(true)} id="trigger-button" />}
                          <p style={{ margin: 0, fontSize: '12px', color: '#2d3748' }}>{assetDetail[item.field] || '-'}</p>
                          <IonPopover isOpen={asToggle} mode="ios" backdropDismiss onDidDismiss={() => setAsToggle(false)}>
                            <div style={{ padding: '12px 16px' }}>
                              <IonIcon className="close-icon" onClick={() => setAsToggle(false)} src={close} />
                              <div className="preview-container"><p className="preview-key">{t('Assets.CreateA.category_name')}</p><p className="preview-value">{color.category_name}</p></div>
                              <div className="preview-container"><p className="preview-key">{t('Assets.CreateA.color')}</p><p className="preview-value">{color.color}</p></div>
                            </div>
                          </IonPopover>
                        </div>
                      ) : item.field === 'status' ? (
                        <span style={{ fontSize: '12px', fontWeight: 600, color: assetDetail[item.field]?.includes('Need') ? '#e53935' : '#2d3748' }}>
                          {assetDetail[item.field] && item.translate ? t(`Assets.CreateA.${assetDetail[item.field]}`) : assetDetail[item.field] || '-'}
                        </span>
                      ) : item.field === 'attachment' ? (
                        assetDetail[item.field] ? (
                          <img src={`${localStorage.getItem('baseUrl')?.replace('/api', '')}${assetDetail[item.field]}`} alt="" style={{ width: '80px', borderRadius: '8px', border: '1px solid #e2e8f0' }} />
                        ) : <span style={{ fontSize: '12px', color: '#a0aec0' }}>-</span>
                      ) : (
                        <p style={{ margin: 0, fontSize: '12px', color: '#2d3748', wordBreak: 'break-word' }}>
                          {assetDetail[item.field] && item.translate ? t(`Assets.CreateA.${assetDetail[item.field]}`) : assetDetail[item.field] || '-'}
                        </p>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* Timeline */}
          {assetModal && <AssetTimeline id={assetDetail.asset_name || id} />}
        </div>
      </div> : null}
    </div>
  );
};

export default AssetOnMapModal;
